import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import languagesJson from '../../../localess.js/languages.json';
import profile from '../.././../assets/img/login_page.jpg';
import vertiasLogo from '../.././../assets/img/vertiasLogistic.png';
import { Link } from 'react-router-dom';
import './Login.css';
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Label,
} from "reactstrap";
import authentication from "../../../utils/authentication";
import firebase from '../../../firebase';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgotPassword from "./ForgotPassword";
import constants from '../../../constants/constant';
import PhoneInput from 'react-phone-input-2';
import toastService from "../../../utils/toastnotification";
import axios from "axios";
import ii8n from '../../../i18n'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';


const authenticationService = new authentication();
const toastservice = new toastService();

class Login extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.login = this.login.bind(this);
    this.loginKeyUp = this.loginKeyUp.bind(this)
    this.openPopupbox = this.openPopupbox.bind(this);

    this.state = {
      username: "",
      password: "",
      isPopupOpen: false,
      showOTP: false,
      showOTPEntryScreen: false,
      country_code: '',
      count: 0,
      changePassword: false,
      subDomain: '',
      loginLoading: false,
      showPassword: false
    };
  }
  componentWillMount() {
    if (localStorage.getItem('user_info')) {
      window.location.href = '/'
    }
    else {
      const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;
      if (messaging) {
        messaging.requestPermission()
          .then(function () {
            return messaging.getToken();
          })
          .then(function (token) {
            localStorage.setItem("fcmToken", token);
          })
          .catch(function (err) {
            console.log("Error " + err);
          })
      }
    }
  }

  componentDidMount() {
    let host = window.location.host;
    console.log(window.location.host);
    let parts = host.split(".");
    let subdomain = "";
    if (parts.length >= 3) {
      subdomain = parts[0];
      this.setState({
        subDomain: subdomain.substring(subdomain.indexOf('//') + 2)
      })
    }
  }

  async fcmToken(changePassword) {
    await authenticationService
      .fcmTokenRequest(localStorage.getItem('fcmToken'))
      .then(response => {
        if (response.status === 200) {
          if (!changePassword) { window.location = "/" }
          else { window.location = "/profile/password" }
        }
        else {
          if (localStorage.getItem('user_info')) {
            if (!changePassword) { window.location = "/" }
            else { window.location = "/profile/password" }
          }
        }
      });
  }

  loginKeyUp(event) {

    if (event.key === 'Enter') {
      const button = document.getElementById("loginBtn")
      button.style.backgroundColor = "#AB4283"
      button.style.color = "#ffffff"
      this.login(event)
    }

  }

  async  login(event) {
    this.setState({
      loginLoading: true
    })
    event.preventDefault();
    let changePassword=false;
    var userName = this.state.username.toLowerCase();
    await authenticationService
      .loginRequest(userName, this.state.password,this.state.showOTP,this.state.country_code)
      .then(response => {
        const button = document.getElementById("loginBtn")
        button.style.backgroundColor = "#FFFFFF"
        button.style.color = "#000000"
        if (response.status === 200) {
          localStorage.setItem('entity_id', response.data.entity_id)
          changePassword=response.data.change_password
          this.setUserInfoInLocalStorage(response)
            .then(response => {
              this.fcmToken(changePassword)
              this.setTranslationLanguage()
            })
            this.setState({
              loginLoading: false
            })
        } else {
          toastservice.error(response["message"]);
          this.setState({
            loginLoading: false
          })
        }
      });
  }

  setTranslationLanguage() {
    if(this.props.i18n!=undefined){
    this.props.i18n.changeLanguage(localStorage.getItem("user_preffered_language"));
    }
  }

  genrateOTPlogin(event) {
    var username;
    var country_code;
    if (this.state.showOTP) {
      username = this.state.username.slice(-10);
      country_code = this.state.username.replace(username, '')
    }
    event.preventDefault();
    var params = { "mobile_no": username, "country_code": "+" + country_code }
    authenticationService
      .genrateOTP(params)
      .then(response => {
        if (response.status === 200) {
          this.setState({ showOTPEntryScreen: true, password: '', username: username, country_code: country_code, userName: username });
        }
      });

  }

  setUserInfoInLocalStorage(apiresponse) {
    return new Promise((resolve, reject) => {

      var userInfoObj = JSON.parse(JSON.stringify(apiresponse["data"]))
      if (userInfoObj.preffered_language === "SYSTEM_PROVIDED") {
        if (Object.keys(languagesJson).includes(navigator.language)) {
          let selectedLanguageObj = languagesJson[navigator.language]
          if (selectedLanguageObj && selectedLanguageObj.name && Object.keys(ii8n.store.data).includes(selectedLanguageObj.name.toUpperCase())) {
            localStorage.setItem("user_preffered_language", selectedLanguageObj.name.toUpperCase())
          } else {
            localStorage.setItem("user_preffered_language", "ENGLISH")
          }
        } else {
          localStorage.setItem("user_preffered_language", "ENGLISH")
        }
      } else if (Object.keys(ii8n.store.data).includes(userInfoObj.preffered_language)) {
        localStorage.setItem("user_preffered_language", JSON.parse(JSON.stringify(apiresponse["data"])).preffered_language)
      } else {
        localStorage.setItem("user_preffered_language", "ENGLISH")
      }

      localStorage.setItem("user_info", JSON.stringify(apiresponse["data"]));
      localStorage.setItem("change_password", JSON.parse(JSON.stringify(apiresponse["data"])).change_password);

      localStorage.setItem("isLoggedin", "true");
      localStorage.setItem("token", apiresponse["headers"]["x-auth-token"]);
      localStorage.setItem(
        "serveruniqueid",
        apiresponse["headers"]["server_unique_id"]
      );
      localStorage.setItem(
        "refreshtoken",
        apiresponse["headers"]["refresh-token"]
      );
      resolve();
    })
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  handleInputChangeForUserName(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    if (!isNaN(Number(event.target.value)) && event.target.value.length > 0) {

      this.setState({ showOTP: true, [name]: value })
    }
    else {

      this.setState({
        [name]: value, showOTP: false
      });
    }
  }

  handleInputChangeForNumber(value, country, event, formattedValue) {
    if (value.length > 0) {
      this.setState({
        username: value
      });
    }
    if (event.target != null) {
      if (event.target.value === "+" + country.dialCode) {
        this.setState({
          showOTP: false,
          username: "",
        });
      }
    }
  }

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword
    }));
  }

  openPopupbox() {
    this.setState({ isPopupOpen: !this.state.isPopupOpen });
  }

  render() {
    const {password, username, showPassword, loginLoading} = this.state;
    const isFieldsFilled = username.trim() !== '' && password.trim() !== '';
    const buttonStyle = {
      backgroundColor: isFieldsFilled ? "#AB4283" : "#FFFFFF",
      color: isFieldsFilled ? "#ffffff" : "#000000"
    };
    var mailLogin = (
      <div className="container-fluid overflow-hidden bg">
        <div className="row">
          <div className="col-lg-6 p-0 position-relative">
            <div className="position-absolute w-100 h-100 image-overlay"></div>
            <img src={profile} className="login-profile" alt="profile" />
          </div>
          <div className="col-lg-6 d-flex flex-column justify-content-center align-items-center">
            <img src={vertiasLogo} alt="Veritas Logo" />
            <span className="login-content">
              Welcome Back! Please Login To Your Account.
            </span>
            <div className="mt-3">
              <div className="mb-3">
                <Label htmlFor="name">Username</Label>
                <Input type="text" id="name" name="username" value={username} onChange={this.handleInputChangeForUserName.bind(this)} onKeyUp={this.loginKeyUp} className="form-control box-content" />
              </div>
              <div className="mb-3">
                <Label htmlFor="password">Password</Label>
                <InputGroup>
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    value={password}
                    onChange={this.handleInputChange}
                    onKeyUp={this.loginKeyUp}
                    className="form-control box-content"
                  />
                  <InputGroupAddon addonType="append">
                    <Button color="secondary" onClick={this.togglePasswordVisibility} onKeyUp={this.loginKeyUp}>
                      <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </div>
              <div className="mb-3">
                <button className="login-btn" onClick={this.login} id="loginBtn" style={buttonStyle}>
                  {loginLoading ? <i class="fa fa-spinner fa-spin mr-2"></i> : null}{("Login")}
                </button>
              </div>
              <div>
                <Link to="/forgotpassword" className="link-color">Forgot Password ?</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
    return (
      <div>
        <ToastContainer />
        {mailLogin}
      </div>
    );
  }
}

export default Login;


